import axios from 'axios'
import { camelizeKeys } from 'humps'

import { TruckbookApiResponseError } from './TruckbookApiResponseError'

export const createTruckbookApiErrorInterceptor =
  () =>
  (error: unknown): Promise<never> => {
    if (!axios.isAxiosError(error) || !error.response) {
      return Promise.reject(error)
    }

    const rawData = error.response.data
    if (rawData instanceof Blob) {
      return Promise.reject(error)
    }

    const camelized = camelizeKeys(rawData) as unknown
    if (!TruckbookApiResponseError.isApiErrorResponseBody(camelized)) {
      return Promise.reject(error)
    }

    return Promise.reject(new TruckbookApiResponseError(camelized, error.response.status, error))
  }
